<template>
  <div class="rank" :class="['rank4' + status]">
    <img class="posterBg" :src="rankBg" />
    <main>
      <section>
        <p>{{ posterData.serviceName }}</p>
        <dl>
          <dt>{{ posterData.realName }}</dt>
          <dd>经过努力学习，【{{ posterData.subjectName }}】段位提升</dd>
          <dd>{{ timeFormatFilter(posterData.date) }}</dd>
        </dl>
      </section>
      <footer>
        <div>
          <span v-if="posterData.segmentId < 42">{{
            posterData.segmentLevel
          }}</span>
          <img :src="posterData.segmentIcon" />
        </div>
        <p>
          <span>{{ posterData.segmentName }}段位</span>
        </p>
        <img
          class="committeeSeal"
          src="../../../../assets/images/winterGame/poster/committeeSeal.png"
        />
      </footer>
    </main>
  </div>
</template>

<script>
/** 段位 id 用于区分段位等级
 * 23 3 热血黑铁
 * 24 2热血黑铁
 * 25 1热血黑铁
 * 26 3朝气白银
 * 27 2 朝气白银
 * 28 1朝气白银
 * 29 4 无畏黄金
 * 30 3 无畏黄金
 * 31 2 无畏黄金
 * 32 1无畏黄金
 * 33 4 耀世铂金
 * 34 3 耀世铂金
 * 35 2耀世铂金
 * 36 1耀世铂金
 * 37 5璀璨钻石
 * 38 4 璀璨钻石
 * 39 3璀璨钻石
 * 40 2璀璨钻石
 * 41 1璀璨钻石
 * 42 0超凡王者
 * 43 0至尊王者
 * 44 0傲世王者
 */
import { timeFormatFilter, judgeTempSeason, compareTime } from "@/util/util.js";
export default {
  name: "rank",
  props: {
    status: {
      type: Number,
      default: 1,
    },
    posterData: {
      type: Object,
      default: function () {
        return {
          realName: "",
          subjectName: "",
          date: "",
          segmentName: "",
          segmentLevel: "",
          segmentId: "",
          isSpring: false,
        };
      },
    },
    teamInfo: {
      type: Object,
      default: null,
    },
    // 升段海报配置
    rankPosterConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rankBg: "",
      seasonId:'',
      officialGame: '',
      year:'',
      season:'',
    };
  },
  methods: {
    timeFormatFilter(date) {
      return timeFormatFilter(date);
    },
  },
  mounted() {
    let [isSpring, year, season] = judgeTempSeason();
    this.isSpring = isSpring;
    this.year = year;
    this.season = season;
    this.officialGame = compareTime()
    if (this.posterData.segmentId >= 42) {
        // 升级海报-超凡王者
        this.rankBg = this.rankPosterConfig.rankKing;
      } else {
        this.rankBg = this.rankPosterConfig.rankNormal;
      }
  },
};
</script>

<style lang="less" scoped>
.rank {
  display: flex;
  flex-direction: column;
  img.posterBg {
    width: 100%;
  }
  > main {
    position: absolute;
    top: 352px;
  }
  section {
    position: relative;
    margin-top: -40px;
    &:first-child {
      p {
        text-align: center;
        font-size: 32px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
      }
      dl {
        margin: 20px 0 0;
        text-align: center;
        dt {
          margin-left: 0;
          font-size: 64px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #ffffff;
          margin-bottom: 20px;
        }
        dd {
          margin: 0;
          font-size: 24px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #f6f9fd;
          line-height: 30px;
        }
      }
    }
  }
  footer {
    position: relative;
    top: -60px;
    div {
      text-align: center;
      position: relative;
      span {
        position: absolute;
        top: 58%;
        left: 49%;
        height: 80px;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 80px;
      }
      img {
        width: 70%;
        margin-top: 40px;
      }
    }
    p {
      position: relative;
      top: -50px;
      margin: 0;
      height: 80px;
      line-height: 80px;
      text-align: center;
      background: url("../../../../assets/images/winterGame/place/placeBg.png")
        no-repeat center;
      background-size: contain;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #efd193;
      }
    }
    img.committeeSeal {
      width: 30%;
      position: absolute;
      right: 60px;
      bottom: 60px;
    }
  }
}
</style>
